<script setup>
import { watch } from 'vue';
import { useAuthStore } from './stores/auth';
import { useCatalogStore } from './stores/catalog';
import { useClientDocumentsStore } from './stores/clientDocuments';
import { useProjectsStore } from './stores/projects';

const authStore = useAuthStore();
const catalogStore = useCatalogStore();
const clientDocumentsStore = useClientDocumentsStore();
const projectsStore = useProjectsStore();

watch(
	() => authStore.isAuthenticated,
	(isAuthenticated) => {
		if (isAuthenticated) {
			catalogStore.bootstrap();
			clientDocumentsStore.fetchDocuments().catch(() => {});
			projectsStore.ensureInitialized();
		} else {
			catalogStore.reset();
			clientDocumentsStore.reset();
			projectsStore.reset();
		}
	},
	{ immediate: true }
);
</script>

<template>
  <router-view />
 </template>
